<template>
  <section id="container" class="gnb_pdt">
    <div>
      <div class="title_wrap">
        <h1>파우치 {{ isUpdate ? '수정' : '등록' }}</h1>
      </div>
    </div>

    <div class="contents_wrap">
      <div class="small_title_wrap">
        <h2>기본정보</h2>
      </div>
      <div class="cmdp_photo">
        <span v-if="!!!pouchInfo.imgFile"><img src="@/assets/img/etners-main/aiportal_img.png"></span>
        <span id="previewImage" v-show="pouchInfo.imgFile !== null"></span>
        <div class="upload">
          <send-file-upload
              ref="fileUploadRef"
              @child="getFileData"
              v-bind:file="[]"
          >
          </send-file-upload>
        </div>
      </div>
      <ul class="filter_list user_photo_right">
        <li>
          <dd>
            <label>No.</label>
            <ul class="w75">
              <li v-if="isUpdate">
                <span> {{ pouchInfo.itemId }} </span>
              </li>
              <li v-else>
                <span class="forg"> 등록 시 자동 생성 </span>
              </li>
            </ul>
          </dd>
        </li>
        <li>
           <dd>
            <label>배송 상태</label>
            <ul>
              <li v-if="isUpdate">
                <span> {{ pouchInfo.statusNm }} </span>
              </li>
              <li v-else>
                <span> 수거 등록 </span>
              </li>
            </ul>
          </dd>
        </li>
        <li>
           <dd>
            <label>내용<span class="forg">*</span></label>
            <ul class="w80">
              <li>
                <div v-for="item in pouchContentsScnList">
                  <input
                      class="k-radio"
                      type="radio"
                      name="contentScnPouch1"
                      :id="`${item.cdId}_pContentsScn1`"
                      @change="pouchInfo.contentsScn = item.cdId"
                      :value="item.cdId"
                      :checked="item.cdId === pouchInfo.contentsScn">
                  <label :for="`${item.cdId}_pContentsScn1`" class="k-radio-label">{{ item.cdNm }}</label>
                  <input
                      class="mgt5 w70"
                      v-show="item.cdId === '04' && pouchInfo.contentsScn === '04'"
                      v-model="pouchInfo.contentsDesc"
                      placeholder="내용을 입력하세요."
                  >
                </div>
              </li>
            </ul>
          </dd>
        </li>
        <li v-if="isUpdate">
          <dd>
            <label>등록자</label>
            <ul class="w50">
              <li>
                {{ pouchInfo.frstRgstId }} | {{ pouchInfo.frstRgstDt }}
              </li>
            </ul>
          </dd>
        </li>
        <li v-if="isUpdate">
          <dd>
            <label>최종 메일 발송일</label>
            <ul>
              <li>
                <span> {{ pouchInfo.lastEmailSendDt === null ? '-' : pouchInfo.lastEmailSendDt }} </span>
              </li>
            </ul>
          </dd>
        </li>
      </ul>
    </div>
<div class="box_flex mgt20">
    <div class="contents_wrap">
      <div class="small_title_wrap">
        <h2>발신 정보</h2>
      </div>
      <ul class="filter_list">
        <li>
          <dd>
            <label class="w30">발신 사업장<span class="forg">*</span></label>
            <ul class="w70">
              <li>
                <kendo-dropdownlist
                    class="w100"
                    ref="sendFacilityRef"
                    :data-text-field="'cdNm'"
                    :data-value-field="'cdId'"
                    v-model="pouchInfo.sendFacility"
                    :option-label="'발신 사업장 선택'"
                    :data-source="zone1DepthListForPouch"
                    @change="pouchInfo.sendArea=null; pouchInfo.sendCourse=null; pouchInfo.sendBuilding=null; pouchInfo.sendFloor=null; onChangeFacility('send')"
                    :filter="'contains'"
                >
                </kendo-dropdownlist>
              </li>
            </ul>
          </dd>
          <dd>
            <label class="w30">발신<span class="forg">*</span></label>
            <ul class="w70">
              <li>
                <kendo-maskedtextbox
                    class="w100"
                    :placeholder="'발신처 입력'"
                    v-model.trim="pouchInfo.sendNm"
                >
                </kendo-maskedtextbox>
              </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label class="w30">발신 거점</label>
            <ul class="w70">
              <li>
                <kendo-dropdownlist
                    class="w100"
                    ref="sendAreaRef"
                    :disabled="!isSendDs"
                    :data-text-field="'cdNm'"
                    :data-value-field="'cdId'"
                    v-model="pouchInfo.sendArea"
                    :option-label="'발신 거점 선택'"
                    @change="pouchInfo.sendCourse=null; pouchInfo.sendBuilding=null; pouchInfo.sendFloor=null; onChangeArea('send')"
                >
                </kendo-dropdownlist>
              </li>
            </ul>
          </dd>
          <dd>
            <label class="w30">발신 부서<span class="forg">*</span></label>
            <ul class="w70">
              <li>
                <kendo-maskedtextbox
                    class="w100"
                    :placeholder="'발신 부서 입력'"
                    v-model.trim="pouchInfo.sendDept"
                >
                </kendo-maskedtextbox>
              </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label class="w30">발신 코스</label>
            <ul class="w70">
              <li>
                <kendo-dropdownlist
                    class="w100"
                    ref="sendCourseRef"
                    :disabled="!isSendDs"
                    :data-text-field="'cdNm'"
                    :data-value-field="'cdId'"
                    v-model="pouchInfo.sendCourse"
                    :option-label="'발신 코스 선택'"
                    @change="pouchInfo.sendBuilding=null; pouchInfo.sendFloor=null; onChangeCourse('send')"
                >
                </kendo-dropdownlist>
              </li>
            </ul>
          </dd>
          <dd>
            <label class="w30">이메일<span v-if="isSendDs" class="forg">*</span></label>
            <ul class="w70">
              <li>
                <kendo-maskedtextbox
                    class="w100"
                    :disabled="!isSendDs"
                    :placeholder="'이메일을 입력하세요.'"
                    v-model.trim="pouchInfo.sendMailAddr"
                >
                </kendo-maskedtextbox>
              </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label class="w30">건물</label>
            <ul class="w70">
              <li>
                <kendo-dropdownlist
                    class="w100"
                    ref="sendBuildingRef"
                    :disabled="!isSendDs"
                    :data-text-field="'cdNm'"
                    :data-value-field="'cdId'"
                    v-model="pouchInfo.sendBuilding"
                    :option-label="'건물 선택'"
                    @change="pouchInfo.sendFloor=null; onChangeBuilding('send')"
                >
                </kendo-dropdownlist>
              </li>
            </ul>
          </dd>
          <dd>
            <label class="w30">시간</label>
            <ul class="w70">
              <li>
                <div v-for="item in ampmScnList">
                  <input
                      class="k-radio"
                      type="radio"
                      name="sendAmpmScn1"
                      :id="`S${item.cdId}_1`"
                      :value="item.cdId"
                      @change="pouchInfo.sendAmpmScn = item.cdId"
                      :checked="item.cdId === pouchInfo.sendAmpmScn">
                  <label :for="`S${item.cdId}_1`" class="k-radio-label" style="width:100px">{{ item.cdNm }}</label>
                </div>
              </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label class="w30">층</label>
            <ul class="w70">
              <li>
                <kendo-dropdownlist
                    class="w100"
                    ref="sendFloorRef"
                    :disabled="!isSendDs"
                    :data-text-field="'cdNm'"
                    :data-value-field="'cdId'"
                    v-model="pouchInfo.sendFloor"
                    :option-label="'층 선택'"
                    :filter="'contains'"
                    value="0"
                >
                </kendo-dropdownlist>
              </li>
            </ul>
          </dd>
          <dd>
            <label class="w30">비고</label>
            <ul class="w70">
              <li>
                <kendo-maskedtextbox
                    class="w100"
                    :disabled="!isSendDs"
                    v-model.trim="pouchInfo.sendContents"
                    :option-label="'전체'"
                    :placeholder="'비고를 입력하세요.'"
                >
                </kendo-maskedtextbox>
              </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label class="w30">구역</label>
            <ul class="w70">
              <li>
                <kendo-maskedtextbox
                    class="w100"
                    ref="sendZoneRef"
                    :disabled="!isSendDs"
                    v-model.trim="pouchInfo.sendZone"
                    :placeholder="'구역을 입력하세요.'"
                >
                </kendo-maskedtextbox>
              </li>
            </ul>
          </dd>
        </li>
      </ul>
    </div>
    <div class="contents_wrap">
      <div class="small_title_wrap">
        <h2>수신 정보</h2>
      </div>
      <receive-info
          ref="receiveInfoRef"
          :propsPouchInfo="pouchInfo"
      >
      </receive-info>
    </div>
</div>
    <div class="button_area w30">
      <ul v-if="isUpdate">
        <li class="w25"><button class="large_btn" @click="redirectToDetail">취소</button></li>
        <li class="w25"><button class="large_btn orange" @click="savePouch('N')">저장</button></li>
      </ul>
      <ul v-else>
        <li class="w25"><button class="large_btn" @click="redirectToList">목록</button></li>
        <li class="w25"><button class="large_btn green" @click="savePouch('N')">저장</button></li>
        <li class="w25"><button class="large_btn orange" :disabled="!isSendDs" @click="savePouch('Y')">등록 (메일)</button></li>
      </ul>
    </div>
  </section>
</template>

<script>

import SendFileUpload from "@/components/send/SendFileUpload.vue";
import SearchSendNm from "@/components/pouch/SearchSendNm.vue";
import ApiConfig from "@/api/api.config";
import ApiUtil from "@/api/api.util";
import {LogisticsCodeDtlMixin, ZoneMixin} from "@/mixin/Mixin";
import EtnersLogisticsUtil from "@/common/etners.logistics.util";
import ReceiveInfo from "@/components/pouch/ReceiveInfo";
import EtnersCommonUtil from "@/common/etners.common.util";

export default {
  name: "PouchReceiveSave",
  components: {SendFileUpload, SearchSendNm, ReceiveInfo},
  mixins: [LogisticsCodeDtlMixin, ZoneMixin],
  mounted() {
    const vm = this

    if(EtnersCommonUtil.isNotEmpty(this.$route.params.isCopy)) {
      vm.isUpdate = false
      vm.callPouchDetail()

    } else if(EtnersCommonUtil.isNotEmpty(this.$route.params.pouchId)) {
      vm.isUpdate = true
      vm.callPouchDetail()
    } else {

      // 사업장, 거점 세팅
      vm.$refs.sendFacilityRef.kendoWidget().value(vm.loginUserData.facility)
      vm.onChangeFacility('send')
      vm.$refs.sendAreaRef.kendoWidget().value(vm.loginUserData.area)
      vm.onChangeArea('send')
    }
  },
  methods: {
    callPouchDetail () {
      const vm = this
      const param = {
        loginUserToken: vm.loginUserToken,
        pouchId: vm.$route.params.pouchId,
      }

      const jsonUrl = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/pouch/pouchDetail.json`
      ApiUtil.post(jsonUrl, param).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          return false
        }
        const resultStatus = response.data.resultStatus
        if (resultStatus.messageCode !== '2000') {
          kendo.alert(resultStatus.messageText)
          return false
        }
        const resultData = response.data.resultData

        vm.pouchInfo = resultData.pouchInfo
        if(resultData.fileInfo !== null){
          vm.fileSrc = `${ApiConfig.eklDomain}/files/2000/${resultData.fileInfo.fileId}/0?lutk=${vm.loginUserToken}`
        }

        // 사업장 세팅 (발신)
        vm.$refs.sendFacilityRef.kendoWidget().value(vm.pouchInfo.sendFacility)
        vm.onChangeFacility('send')
        vm.$refs.sendAreaRef.kendoWidget().value(vm.pouchInfo.sendArea)
        vm.onChangeArea('send')
        vm.$refs.sendCourseRef.kendoWidget().value(vm.pouchInfo.sendCourse)
        vm.onChangeCourse('send')
        vm.$refs.sendBuildingRef.kendoWidget().value(vm.pouchInfo.sendBuilding)
        vm.onChangeBuilding('send')
      })

    },
    onChangeFacility (gbn) {
      const vm = this
      vm.onChange1Depth(`${gbn}FacilityRef`)
      vm.$refs[`${gbn}AreaRef`].kendoWidget().setDataSource(vm.zone2DepthListForPouch)
      vm.$refs[`${gbn}AreaRef`].kendoWidget().value(vm.pouchInfo[`${gbn}Area`])

      // 발신 사업장에 따라 필수값 변동
      const facility = vm.$refs.sendFacilityRef.kendoWidget().value()
      const dsArray = ['01', '02', '03', '04', '05', '06']
      vm.isSendDs =  dsArray.includes(facility)
    },
    onChangeArea (gbn) {
      const vm = this
      vm.onChange2Depth(`${gbn}AreaRef`)
      vm.$refs[`${gbn}CourseRef`].kendoWidget().setDataSource(vm.zone3DepthList)
      vm.$refs[`${gbn}CourseRef`].kendoWidget().value(vm.pouchInfo[`${gbn}Course`])
    },
    onChangeCourse (gbn) {
      const vm = this
      vm.onChange3Depth(`${gbn}CourseRef`)
      vm.$refs[`${gbn}BuildingRef`].kendoWidget().setDataSource(vm.zone4DepthList)
      vm.$refs[`${gbn}BuildingRef`].kendoWidget().value(vm.pouchInfo[`${gbn}Building`])
    },
    onChangeBuilding (gbn) {
      const vm = this
      vm.onChange4Depth(`${gbn}BuildingRef`)
      vm.$refs[`${gbn}FloorRef`].kendoWidget().setDataSource(vm.zone5DepthList)
      vm.$refs[`${gbn}FloorRef`].kendoWidget().value(vm.pouchInfo[`${gbn}Floor`])
    },
    getFileData (fileInfo) {
      const vm = this
      vm.pouchInfo.imgFile = fileInfo

      // 미리보기 세팅
      setTimeout(() => {
        const raw = fileInfo[0].rawFile
        const reader = new FileReader()
        const name = fileInfo[0].name
        if (raw) {
          reader.onloadend = function () {
            document.getElementById('previewImage').innerHTML = '<img alt=' + name + ' src=' + this.result + ">"
          }

          reader.readAsDataURL(raw)
        }
      })
    },
    getPouchInfo () {
      const vm = this
      const refs = this.$refs
      const pouchInfo = vm.pouchInfo

      if(EtnersCommonUtil.isNotEmpty(refs.sendFacilityRef)){
        pouchInfo.sendFacility = refs.sendFacilityRef.kendoWidget().value()
      }
      if(EtnersCommonUtil.isNotEmpty(refs.sendAreaRef)){
        pouchInfo.sendArea = refs.sendAreaRef.kendoWidget().value()
      }
      if(EtnersCommonUtil.isNotEmpty(refs.sendCourseRef)){
        pouchInfo.sendCourse = refs.sendCourseRef.kendoWidget().value()
      }
      if(EtnersCommonUtil.isNotEmpty(refs.sendBuildingRef)){
        pouchInfo.sendBuilding = refs.sendBuildingRef.kendoWidget().value()
      }
      if(EtnersCommonUtil.isNotEmpty(refs.sendFloorRef)){
        pouchInfo.sendFloor = refs.sendFloorRef.kendoWidget().value()
      }

      return pouchInfo
    },
    savePouch (sendMailYn) {
      const vm = this
      vm.pouchInfo = vm.getPouchInfo()
      /*
      DS: 기흥, 화성, DSR, 평택, 온양, 천안, ESOP
      DX: 수원, 서울, 구미, 광주, 기타
      */

      // 필수값 체크
      if (EtnersCommonUtil.isEmpty(vm.pouchInfo.sendFacility)) {
        kendo.alert('발신 사업장을 선택해주세요.')
        return false
      }
      if (EtnersCommonUtil.isEmpty(vm.pouchInfo.sendNm)) {
        kendo.alert('발신을 입력해주세요.')
        return false
      }
      if (EtnersCommonUtil.isEmpty(vm.pouchInfo.sendDept)) {
        kendo.alert('발신 부서를 입력해주세요.')
        return false
      }
      if (vm.isSendDs && EtnersCommonUtil.isEmpty(vm.pouchInfo.sendMailAddr)) {
        kendo.alert('이메일을 입력해주세요.')
        return false
      } else if (EtnersCommonUtil.isNotEmpty(vm.pouchInfo.sendMailAddr)) {
        if (!EtnersLogisticsUtil.isEmailDomainAllowed(vm.pouchInfo.sendMailAddr)) {
          kendo.alert(EtnersLogisticsUtil.getEmailDomainAllowedMsg("발신"))
          return
        }
      }

      const receiveInfo = vm.$refs.receiveInfoRef.getReceiveInfo()
      if (!receiveInfo) {
        return
      }

      vm.pouchInfo = {
        ...vm.pouchInfo,
        ...receiveInfo
      }

      if (vm.isUpdate) {
        vm.callUpdateApi()
      } else {
        vm.callSaveApi(sendMailYn)
      }
    },
    callSaveApi (sendMailYn) {
      const vm = this
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/pouch/savePouch.json`
      const formData = new FormData()
      const params = {
        loginUserToken: vm.loginUserToken,
        pouchInfo: {
          ...vm.pouchInfo
          ,contentsDesc: (vm.pouchInfo.contentsScn === '04' ? vm.pouchInfo.contentsDesc : null )
        }
      }
      if(vm.pouchInfo.imgFile){
        vm.pouchInfo.imgFile.forEach(function (v) {
          formData.append('file', v.rawFile)
        })
      }
      formData.append('pouchSaveRequestParam', new Blob([JSON.stringify(params)],{
        type: 'application/json',
      }))

      // API 호출
      ApiUtil.postIncludeUploadFile(url, formData).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          return false
        }
        const resultStatus = response.data.resultStatus
        if (resultStatus.messageCode !== '2000') {
          kendo.alert(resultStatus.messageText)
          return false
        }
        if (sendMailYn === 'Y') {
          // 파우치 등록 후 메일 발송
          vm.pouchInfo.pouchId = response.data.resultData.pouchId
          vm.callSendMailApi()
        } else {
          // only 등록
          kendo.alert('등록되었습니다.')
          vm.redirectToList()
        }
      })
    },
    callUpdateApi () {
      const vm = this
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/pouch/pouchUpdate.json`
      const formData = new FormData()
      const params = {
        loginUserToken: vm.loginUserToken,
        pouchInfo: {
          ...vm.pouchInfo
          ,contentsDesc: (vm.pouchInfo.contentsScn === '04' ? vm.pouchInfo.contentsDesc : null )
        }
      }

      if(vm.pouchInfo.imgFile){
        vm.pouchInfo.imgFile.forEach(function (v) {
          formData.append('file', v.rawFile)
        })
      }
      formData.append('pouchUpdateRequestParam', new Blob([JSON.stringify(params)],{
        type: 'application/json',
      }))

      kendo.confirm("해당 건을 수정하시겠습니까?").done(() => {
        ApiUtil.postIncludeUploadFile(url, formData).then(response => {
          if (response.data === undefined || response.data.resultStatus === undefined) {
            kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
            return false
          }
          const resultStatus = response.data.resultStatus
          if (resultStatus.messageCode !== '2000') {
            kendo.alert(resultStatus.messageText)
            return false
          }
          kendo.alert('수정되었습니다.')
          vm.redirectToDetail()
        })
      })
    },
    callSendMailApi () {
      const vm = this
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/pouch/sendPouchSendMail.json`
      const params = {
        loginUserToken: vm.loginUserToken,
        pouchIdList: [vm.pouchInfo.pouchId]
      }

      ApiUtil.post(url, params).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          return false
        }
        const resultStatus = response.data.resultStatus
        if (resultStatus.messageCode !== '2000') {
          kendo.alert('메일이 발송되지 않고 등록되었습니다.')
          vm.redirectToList()
        } else {
          kendo.alert('메일 발송 후 등록되었습니다.')
          vm.redirectToList()
        }
      })
    },
    redirectToList () {
      this.$router.push({
        name: "PouchList"
      })
    },
    redirectToDetail () {
      this.$router.push({
        name: "PouchDetail",
        params: {
          pouchId: this.pouchInfo.pouchId
        }
      })
    },
  },
  data () {
    const loginUserData = JSON.parse(sessionStorage.getItem("loginUserData"))
    // 현재 시간에 따른 발신 시간 디폴트 지정
    const date = new Date()
    const sendAmpmScn = date.getHours() < 12 ? '01' : '02'

    return {
      loginUserToken: sessionStorage.getItem('loginUserToken'),
      loginUserData: loginUserData,

      isUpdate: false,
      isSendDs: false,

      pouchInfo: {
        itemId: null,
        status: '01', // 수거 등록
        contentsScn: '04', // 기타

        sendFacility: null,
        sendArea: null,
        sendCourse: null,
        sendBuilding: null,
        sendFloor: null,
        sendZone: null,
        sendNm: null,
        sendDept: null,
        sendMailAddr: null,
        sendAmpmScn: sendAmpmScn,
        sendContents: null,

        receiveFacility: null,
        receiveArea: null,
        receiveCourse: null,
        receiveBuilding: null,
        receiveFloor: null,
        receiveZone: null,
        receiveNm: null,
        receiveDept: null,
        receiMailAddr: null,
        receiveAmpmScn: null,
        receiveContents: null,

        imgFile: null,
      }
    }
  }
}
</script>

<style scoped>

</style>